import React from 'react';
import { Link } from 'react-router-dom';
import SharedNavbar from '../components/SharedNavbar';
import './LearningPage.css';

const LearningPage = () => {
  return (
    <div className="learning-page">
      <SharedNavbar />

      {/* ===== HERO BANNER ===== */}
      <section className="lp-hero">
        <div className="lp-hero-content">
          <div className="lp-hero-text">
            <h1>Personal and Professional Development</h1>
            <p>Membership to DAMA Tunisia enables access to a great deal of resources and opportunities for development.</p>
          </div>
        </div>
      </section>

      {/* ===== INTRO TEXT + SIGNPOSTS ===== */}
      <section className="lp-intro">
        <div className="lp-container">
          <div className="lp-intro-inner">

            {/* Texte à gauche */}
            <div className="lp-intro-text">
              <p>
                At DAMA Tunisia, we're committed to supporting our members at every stage of their data management journey.
                As part of your membership, you gain access to a wide range of resources and opportunities designed to
                enhance both your personal and professional growth.
              </p>
              <p>
                From internationally recognised certifications like the <strong>CDMP®</strong>, to tailored courses,
                mentoring, webinars, and exclusive access to expert resources aligned with the <strong>DAMA-DMBoK®</strong>,
                our development offering is built to help you stay ahead in an evolving industry.
              </p>
              <p className="lp-click-text">
                <strong>Click on the signposts below to explore the different ways DAMA Tunisia can support your development.</strong>
              </p>
            </div>

            {/* Signposts empilés à droite */}
            <div className="lp-signposts">
              <a href="#mentoring" className="lp-signpost lp-sp-1">Mentoring</a>
              <a href="#courses"   className="lp-signpost lp-sp-2">Education and Training</a>
              <Link to="/dmbok"    className="lp-signpost lp-sp-3">DMBoK®</Link>
              <a href="#resources" className="lp-signpost lp-sp-4">Members Resources</a>
            </div>

          </div>
        </div>
      </section>

      {/* ===== DEVELOPMENT SECTION ===== */}
      <section className="lp-development">
        <div className="lp-container">
          <div className="lp-dev-title">
            <h2>Development as a Data Management Professional</h2>
          </div>
          <p>
            Membership to DAMA Tunisia enables access to a great deal of resources and opportunities
            for development, both personal and professional.
          </p>
          <p>
            Non-members can sign up for and access our past range of valuable webinars on{' '}
            <a href="https://www.brighttalk.com" target="_blank" rel="noreferrer" className="lp-link">
              BrightTALK
            </a>.
          </p>

          {/* COURSES + RESOURCES */}
          <div className="lp-two-cols" id="courses">
            <div className="lp-col">
              <div className="lp-col-header courses-header">Courses</div>
              <div className="lp-col-body">
                <p>
                  DAMA Tunisia supports members with access to a variety of{' '}
                  <strong>courses and training events</strong> throughout the year.
                </p>
                <p>
                  Our core focus is the{' '}
                  <strong>Certified Data Management Professional (CDMP®)</strong>{' '}
                  qualification from DAMA International — a globally recognised certification in data management.
                </p>
                <p>
                  DAMA Tunisia runs virtual <strong>CDMP® 3-day Training Courses</strong> annually,
                  exclusively for our members.
                </p>
                <p>
                  We also regularly share other relevant training opportunities, some with{' '}
                  <strong>exclusive member discounts</strong>, to support your ongoing professional development.
                </p>
              </div>
            </div>

            <div className="lp-col" id="resources">
              <div className="lp-col-header resources-header">Resources</div>
              <div className="lp-col-body resources-body">
                <p>DAMA Tunisia members have access to a range of valuable resources, including:</p>
                <a href="#" className="lp-resource-link">Access to upcoming and past member-only webinars</a>
                <a href="#" className="lp-resource-link">Case studies and white papers on industry topics</a>
                <a href="#" className="lp-resource-link">Access to the DAMA Tunisia members' bookstore and discount code</a>
                <a href="#" className="lp-resource-btn">Download Templates and Tools ↗</a>
              </div>
            </div>
          </div>

          {/* MENTORING + DMBOK */}
          <div className="lp-two-cols" style={{ marginTop: '2rem' }}>
            <div className="lp-col" id="mentoring">
              <div className="lp-col-header mentoring-header">Mentoring</div>
              <div className="lp-col-body">
                <p>DAMA Tunisia offers a mentoring service available to all membership levels.</p>
                <p>
                  A network of students and volunteer mentors provide invaluable guidance
                  and networking opportunities.
                </p>
                <a href="#" className="lp-text-link">Learn More About Mentorship</a>
              </div>
            </div>

            <div className="lp-col" id="dmbok">
              <div className="lp-col-header dmbok-header">DMBoK®</div>
              <div className="lp-col-body">
                <p>
                  The DMBoK® is a great resource for anyone on their journey through data management.
                  It is particularly useful to prepare for the CDMP® examinations.
                </p>
                <p>Members receive an exclusive <strong>discount</strong> on both digital and hardcopy versions.</p>
                <a href="#" className="lp-text-link">Order a Copy Online</a>
              </div>
            </div>
          </div>

          {/* CDMP INFO */}
          <div className="lp-cdmp-box" id="cdmp">
            <h3>Find out more about CDMP® from DAMA International</h3>
            <a href="https://dama.org/certification/about-cdmp-certification/" target="_blank" rel="noreferrer" className="lp-cdmp-link">
              More Information
            </a>
          </div>

        </div>
      </section>

      {/* ===== CTA BUTTONS ===== */}
      <section className="lp-cta">
        <div className="lp-container">
          <div className="lp-cta-grid">
            <Link to="/membership" className="lp-cta-btn">
              <strong>Become a member</strong>
              <span>Join today and access all our resources</span>
            </Link>
            <Link to="/events" className="lp-cta-btn">
              <strong>Events</strong>
              <span>Discover upcoming and past events</span>
            </Link>
            <Link to="/about" className="lp-cta-btn">
              <strong>Sponsor us</strong>
              <span>Connect with the Tunisian data community</span>
            </Link>
          </div>
        </div>
      </section>

    </div>
  );
};

export default LearningPage;